<script setup>

import {useClearShipperContact} from "@/composables/bookings/useClearShipperContact";
import {useGetValidatedFields} from "@/composables/common/useGetValidatedFields";
import MultiSearchDropDown from "@/components/common/input/MultiSearchDropDown.vue";
import StaticTooltip from "@/components/common/other/StaticTooltip.vue";
import {useMapShipperContact} from "@/composables/bookings/useMapShipperContact";

const emits = defineEmits(['addNewShipperContact', 'editShipperContact']);

const props = defineProps({

  modelValue: {},
  updateShipperContacts: 0,
  validationViewModel: {}
})

function mapSelectedShipperContactDetail(contact) {

  useMapShipperContact(contact, props.modelValue);

}
</script>

<template>
  <div class="global-contact-select">
    <div class="cmp-multi-booking_address-layout">
      <MultiSearchDropDown
          :key="updateShipperContacts"
          @select="mapSelectedShipperContactDetail"
          @clear="useClearShipperContact(props.modelValue)"
          placeholder="Select..."
          :maxLength="50"
          :width="330"
          :labelWidth="85"
          :requiredField="useGetValidatedFields( props.modelValue.metaData.validatedFields, 'shipperContactFullName' )"
          :allowCustomValue="false"
          :disableFilter="true"
          :selectPrimitiveValue="true"
          v-model:validation-fail="validationViewModel"
          label="Contacts"
          :label-top="true"
          v-model="props.modelValue.shipper.shipperContactFullName"
          :data-source="props.modelValue.shipper.shipperContacts">
      </MultiSearchDropDown>
      <StaticTooltip :icon="false">
        <template #content>
          <div style="width: 240px;">
            Create new contacts for the selected Shipper
          </div>
        </template>
        <img class="global-icon-button"
             v-if="modelValue.shipper.shipperName"
             @click="emits('addNewShipperContact')"
             height="22"
             width="22"
             src="@/assets/icons/akar/akar-icons--circle-plus.png">
      </StaticTooltip>
      <StaticTooltip :icon="false">
        <template #content>
          <div style="width: 300px;">
            Edit the Shipper address, you may also create a new Shipper for your records if you have chosen
            to use un saved address information previously.
          </div>
        </template>
        <img class="global-icon-button"
             @click="emits('editShipperContact')"
             v-if="modelValue.shipper.shipperContactFullName"
             height="24" width="24"
             src="@/assets/icons/akar/akar-icons--edit.png">
      </StaticTooltip>
    </div>
    <div class="cmp-multi-booking_contact-container">
      <div class="cmp-multi-booking_selected-address">
        <div v-if="modelValue.shipper.shipperContactId === 0 && modelValue.shipper.shipperContactFullName.trim().length > 0"
             style="position: absolute; top: 12px; right: 5px">
          <img title="This contact is not saved in your system."
               height="16"
               width="16"
               src="@/assets/icons/unsaved.png">
        </div>
        <div v-if="props.modelValue.shipper.shipperContactFullName.trim().length > 0">
          <div class="cmp-multi-booking_address-heading">Full Name</div>
          <div>{{ props.modelValue.shipper.shipperContactFullName }}</div>
          <div class="cmp-multi-booking_address-heading">Telephone</div>
          <div>{{ props.modelValue.shipper.shipperContactPhone || 'n/a' }}</div>
          <div class="cmp-multi-booking_address-heading">Email</div>
          <div>{{ props.modelValue.shipper.shipperContactEmail || 'n/a' }}</div>
          <div class="cmp-multi-booking_address-heading">Department</div>
          <div>{{ props.modelValue.shipper.shipperContactDepartment || 'n/a' }}</div>
        </div>
        <div v-if="props.modelValue.shipper.shipperContactFullName.trim().length === 0" class="cmp-multi-booking_address-placeholder-wrapper">
          <div style="display:flex; align-items: center">
            <img height="22" width="22" src="@/assets/icons/user_small.png">
            <span>Contact Information</span>
          </div>
          <div class="cmp-multi-booking_address-placeholder cmp-multi-booking_a-p1"></div>
          <div class="cmp-multi-booking_address-placeholder cmp-multi-booking_a-p2"></div>
          <div class="cmp-multi-booking_address-placeholder cmp-multi-booking_a-p3"></div>
          <div class="cmp-multi-booking_address-placeholder cmp-multi-booking_a-p4"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/css/booking/multi-booking.scss';
</style>